import { Modal, BackgroundImage, Title, Box, Image, Button, Group } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import colors from '../../../utils/styles';
import './details.modal.css';

interface DetailsModalProps {
  opened: boolean;
  onClose: () => void;
  title: string;
  titleColor?: string;
  description?: string | React.ReactNode;
  image?: string;
  yOffset?: string;
  imageOnly?: boolean;
}

const DetailsModal = ({ opened, onClose, title, titleColor = 'white', description, image, yOffset, imageOnly }: DetailsModalProps) => {
  const isMobile = useMediaQuery('(max-width: 600px)');
  const isTablet = useMediaQuery('(max-width: 1024px)');
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      size={isMobile ? 'auto' : 'xl'}
      radius="md"
      withCloseButton={false}
      yOffset={!isMobile ? yOffset : yOffset || 0 + '10vh'}
      transitionProps={{ transition: 'fade', duration: 150, timingFunction: 'linear' }}
      removeScrollProps={{ allowPinchZoom: true }}
      styles={{
        content: {
          backgroundColor: colors.appLightBlue,
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)',
          padding: 10,
        },
      }}>
      {imageOnly && image
        ? <Box maw={'100vw'} mx="auto">
          <Image
            src={image}
            radius="md"
            fit="contain"
            style={{
              margin: '0 auto',
              maxHeight: '80vh',
              width: isMobile ? '100%' : isTablet ? '95%' : '90%',
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)'
            }}
          />
        </Box>
        : <Box
          className="responsive-text-container"
          onMouseLeave={() => {
            setTimeout(() => {
              onClose()
            }, 350)
          }}>
          {image
            ? <BackgroundImage src={image} radius="md" style={{ height: isMobile ? 150 : 300, width: '100%', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center' }} >
              <Title order={2} style={{ color: titleColor, textAlign: 'center', backgroundColor: 'rgba(0, 0, 0, 0.3)', padding: '8px', borderRadius: '6px' }}>{title}</Title>
            </BackgroundImage>
            : <Title order={2} style={{ color: titleColor, textAlign: 'center' }}>{title}</Title>}
          <Box style={{ padding: 10, marginTop: 10, color: 'white' }}>{description}</Box>
        </Box>}
        {isMobile && <Group style={{ position: 'sticky', bottom: 0, width: '100%' }}>
          <Button mx="auto" size="xs" mb={imageOnly ? -15 : 0} mt={imageOnly ? 5 : 0} radius="lg" color="grey" onClick={onClose}>Close</Button>
        </Group>}
    </Modal>
  );
};

export default DetailsModal;